module.exports = __webpack_public_path__ + "images/corona2020174dfc6fe2c7c1a012018fd8f0031304.png";